export default __webpack_public_path__ + "static/media/detail.28d28f43.png";